export function debounce(callback, options) {
  let timeoutID
  let lastExec = 0

  function wrapper(...args) {
    var self = this
    var elapsed = Number(new Date()) - lastExec

    function exec() {
      lastExec = Number(new Date())
      callback.apply(self, args)
    }

    function clear() {
      timeoutID = undefined
    }

    if (options.debounceMode && !timeoutID) {
      exec()
    }
    if (timeoutID) {
      clearTimeout(timeoutID)
    }

    if (options.debounceMode === undefined && elapsed > options.delay) {
      exec()
    } else if (options.noTrailing !== true) {
      timeoutID = setTimeout(
        options.debounceMode ? clear : exec,
        options.debounceMode === undefined ? options.delay - elapsed : options.delay,
      )
    }
  }
  return wrapper
}
